import { render } from "./EmbedVideoPlayer.vue?vue&type=template&id=1452ab8a&scoped=true"
import script from "./EmbedVideoPlayer.vue?vue&type=script&lang=js"
export * from "./EmbedVideoPlayer.vue?vue&type=script&lang=js"

import "./EmbedVideoPlayer.vue?vue&type=style&index=0&id=1452ab8a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1452ab8a"]])

export default __exports__